import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-primary text-white py-12 mt-16" style={{ backgroundColor: '#2C3E50' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Sparkles className="h-6 w-6 text-gold" style={{ color: '#D4A574' }} />
              <span className="font-serif text-xl font-bold">Tantra Connect</span>
            </div>
            <p className="text-gray-400 text-sm">Conectando con la esencia del tantra autentico.</p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Enlaces</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <Link to="/services" className="block hover:text-gold">Servicios</Link>
              <Link to="/courses" className="block hover:text-gold">Cursos</Link>
              <Link to="/teachers" className="block hover:text-gold">Profesionales</Link>
              <Link to="/schools" className="block hover:text-gold">Escuelas</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <a href="#" className="block hover:text-gold">Privacidad</a>
              <a href="#" className="block hover:text-gold">Terminos</a>
              <a href="#" className="block hover:text-gold">Cookies</a>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Contacto</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <p>info@tantraconnect.com</p>
              <p>Islas Canarias, Espana</p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; 2026 Tantra Connect. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
